import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/images/pic1.jpg'
import _imports_1 from '../assets/images/pic2.jpg'


const _hoisted_1 = { id: "wrapper" }
const _hoisted_2 = { id: "main" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("section", { id: "one" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "image main",
    "data-position": "center"
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: "banner"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "container" }, [
    /*#__PURE__*/_createElementVNode("header", { class: "major" }, [
      /*#__PURE__*/_createElementVNode("h2", null, "Atchafalaya ATV"),
      /*#__PURE__*/_createElementVNode("p", null, "Service and repair on all makes and models of ATV and UTV.")
    ]),
    /*#__PURE__*/_createElementVNode("p", null, "Locally owned and operated.")
  ])
], -1)
const _hoisted_4 = { id: "two" }
const _hoisted_5 = { class: "container" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h3", null, "Repairs", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, "We are capable of repairing a wide variety of makes and models, including the following and more.", -1)
const _hoisted_8 = { class: "feature-icons" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Honda")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Yamaha")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Polaris")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Can-Am")
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "image avatar" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "pic1"
  })
], -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "image avatar" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "pic2"
  })
], -1)
const _hoisted_15 = { id: "four" }
const _hoisted_16 = { class: "container" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("h3", null, "Contact Us", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", null, "Send us an email for quotes and scheduling.", -1)
const _hoisted_19 = {
  method: "post",
  action: "#",
  id: "contact-form"
}
const _hoisted_20 = { class: "row gtr-uniform" }
const _hoisted_21 = { class: "col-6 col-12-xsmall" }
const _hoisted_22 = { class: "col-6 col-12-xsmall" }
const _hoisted_23 = { class: "col-12" }
const _hoisted_24 = { class: "col-12" }
const _hoisted_25 = { class: "col-12" }
const _hoisted_26 = { class: "actions" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("input", {
    type: "reset",
    value: "Reset Form"
  })
], -1)
const _hoisted_28 = /*#__PURE__*/_createStaticVNode("<section id=\"footer\"><div class=\"container\"><ul class=\"copyright\"><li><a href=\"https://goo.gl/maps/hm6hXh2gnsTV1QuWA\">2053 Atchafalaya River Hwy</a></li><li><a href=\"https://goo.gl/maps/hm6hXh2gnsTV1QuWA\">Breaux Bridge, LA 70515</a></li><li><a href=\"tel:337-322-1966\">337-322-1966</a></li></ul></div><div class=\"container\"><ul class=\"copyright\"><li>© Untitled. All rights reserved.</li><li>Design: <a href=\"http://html5up.net\">HTML5 UP</a></li></ul></div></section>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("section", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _hoisted_7,
          _createElementVNode("ul", _hoisted_8, [
            _createElementVNode("li", null, [
              _createVNode(_component_font_awesome_icon, { icon: "wrench" }),
              _hoisted_9
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_font_awesome_icon, { icon: "wrench" }),
              _hoisted_10
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_font_awesome_icon, { icon: "wrench" }),
              _hoisted_11
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_font_awesome_icon, { icon: "wrench" }),
              _hoisted_12
            ])
          ]),
          _hoisted_13,
          _hoisted_14
        ])
      ]),
      _createElementVNode("section", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _hoisted_18,
          _createElementVNode("form", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  name: "name",
                  id: "name",
                  placeholder: "Name",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.name) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.form.name]
                ])
              ]),
              _createElementVNode("div", _hoisted_22, [
                _withDirectives(_createElementVNode("input", {
                  type: "email",
                  name: "email",
                  id: "email",
                  placeholder: "Email",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.email) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.form.email]
                ])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  name: "subject",
                  id: "subject",
                  placeholder: "Subject",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.subject) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.form.subject]
                ])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _withDirectives(_createElementVNode("textarea", {
                  name: "message",
                  id: "message",
                  placeholder: "Message",
                  rows: "6",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.message) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.form.message]
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("ul", _hoisted_26, [
                  _createElementVNode("li", null, [
                    _createElementVNode("input", {
                      type: "button",
                      class: "primary",
                      value: "Send Message",
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onClickMethod && _ctx.onClickMethod(...args)))
                    })
                  ]),
                  _hoisted_27
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _hoisted_28
  ]))
}